module.exports = __webpack_public_path__ + "img/hangye4.85b9259a.png";